var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#C2CFE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6415 17.283C6.9735 17.283 4 14.3095 4 10.6415C4 6.9735 6.9735 4 10.6415 4C14.3095 4 17.283 6.9735 17.283 10.6415C17.283 14.3095 14.3095 17.283 10.6415 17.283ZM10.6415 15.4717C13.3092 15.4717 15.4717 13.3092 15.4717 10.6415C15.4717 7.97388 13.3092 5.81133 10.6415 5.81133C7.97387 5.81133 5.81132 7.97388 5.81132 10.6415C5.81132 13.3092 7.97387 15.4717 10.6415 15.4717ZM19.7347 19.7347C20.0884 19.381 20.0884 18.8076 19.7347 18.4539L16.7159 15.4351C16.3622 15.0814 15.7888 15.0814 15.4351 15.4351C15.0814 15.7887 15.0814 16.3622 15.4351 16.7159L18.4539 19.7347C18.8076 20.0884 19.3811 20.0884 19.7347 19.7347Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.ccc23067.svg";
export { ForwardRef as ReactComponent };